import "./footer.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhoneFlip, faLocationPin, } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faInstagram } from "@fortawesome/free-brands-svg-icons"
import { Link } from "react-router-dom";

const Footer = () =>{
  const scrollToTop = () => {
    window.scrollTo(0, 0)
}
  return (
    <>
    <div className="footer">

        <div className="content__wrapper">
            <div className="left">
                <h3 className="title">About Us</h3>
                <div className="text">Raydron Equipment is a subsidiary of Raydron Nigeria Limited, founded in 2016, but started operating fully as an equipment manufacturer in 2023. We operate in Lagos, Nigeria. We specialize in building industrial equipment, tools and appliances locally. </div>
            </div>
            <div className="middle">
            <h3 className="title">Quicklinks</h3>
               <span onClick={scrollToTop} className="quicklinks"> <Link to="/about" className="link">About Us</Link></span>
                <span onClick={scrollToTop} className="quicklinks"><Link to="/products" className="link">Products</Link></span>
                <span onClick={scrollToTop} className="quicklinks"><Link to="/contact" className="link">Contact Us</Link></span>
            </div>
            <div className="right">
            <h3 className="title">Contact Us</h3>
            <div className="contact"><span className="icon"><FontAwesomeIcon icon={faLocationPin}/></span><span className="contact__text">100, Ikorodu Road, by Ajegunle Bus Stop, Lagos.</span></div>
            <div className="contact"><span className="icon"><FontAwesomeIcon icon={faPhoneFlip}/></span><span className="contact__text">+2348066816640</span></div>
            <div className="contact"><span className="icon"><FontAwesomeIcon icon={faEnvelope}/></span><span className="contact__text">contact@raydron.com</span></div>
            </div>
        </div>
        <div className="social"><span className="icon__social"><a href="https://facebook.com/raydronmanufacturing" target="_blank" rel="noreferrer" className="link"><FontAwesomeIcon icon={faFacebook} /></a> </span> <span className="icon__social"><a href="https://www.instagram.com/raydronequipmentmanufacturing" target="_blank" rel="noreferrer" className="link"><FontAwesomeIcon icon={faInstagram} /></a></span> </div>
        <div className="copy">Copyright © {(new Date()).getFullYear()} Raydron</div>
    </div>
    </>
  )
}

export default Footer